import React, { useState } from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { monthlyDropdownList, productOrderColumns, productOrderData } from '../../../../Data/DashboardsData/ECommerceData'
import { ProductOrderTitle } from '../../../../Utils/Constants'
import DataTable from 'react-data-table-component'
import { ProductOrderTypes } from '../../../../Types/DashboardsType'
import FilterComponent from '../../Common/FilterComponent'

export default function ProductOrder() {
    const [filterText, setFilterText] = useState('');
    const filteredItems: ProductOrderTypes[] = productOrderData.filter(
        (item: ProductOrderTypes) => {
            return Object.values(item).some((value) =>
                value && value.toString().toLowerCase().includes(filterText.toLowerCase())
            );
        }
    );
    return (
        <Col xxl={6} xl={7} className="box-col-7">
            <Card>
                <DropdownWithHeader headerClass='pb-0' heading={ProductOrderTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody className="px-0 pb-0 product-order">
                    <FilterComponent
                        onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                        filterText={filterText}
                    />
                    <div className="table-responsive custom-scrollbar">
                        <DataTable data={filteredItems} columns={productOrderColumns} className='display' />
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}